<app-inventory-template
  [inventoryOptions]="{
  items_load_endpoint: 'load_cf_inventory',
  items_search_enabled: true,
  items_sort_enabled: true,
  items_pure_filter_enabled: !isJoinModal(),
  typography_action_button: isJoinModal() ? 'Join Game' : 'Create Coinflip',
  typography_title: isJoinModal() ? 'Join Coinflip' : 'Create Coinflip',
}"
  [requirementsOptions]="{
    requirements_title: isJoinModal() ? 'Join Coinflip' : 'Create Coinflip',
    requirements_accent_word: 'bet',
    requirements_options_min_value: isJoinModal() ? coinflip()?.min_val ?? 0 : 2,
    requirements_options_max_value: isJoinModal() ? coinflip()?.max_val ?? 0 : 5000,
    requirements_options_min_items: 1,
    requirements_options_max_items: 20,
  }"
  [inventorySkinsListConfig]="{
    columns: 7,
    responsive_columns: true,
    skin_min_width: '100px',
  }"
  [(pure)]="pure"
  [(selectedSkins)]="selectedSkins"
  [isProcessing]="isProcessing()"
  (action)="isJoinModal() ? joinCoinflip() : createCoinflip()"
>
  <ng-content inventory-top>
    @if (isJoinModal() && coinflip()?.is_pure) {
    <div class="divider vertical h-24"></div>
    <div
      class="box box-yellow-08 h-36 gap-8 padding-x-8 flex items-center gap-4"
    >
      Only pure items allowed

      <button type="button" [ngpTooltipTrigger]="pureModeDescriptionTooltip" [ngpTooltipTriggerHideDelay]="0">
        <svg-icon
          class="cf--pure-mode__tooltip-icon flex items-center justify-center s-14"
          src="assets/icons/shared/info.svg"
        ></svg-icon>
      </button>
      <ng-template #pureModeDescriptionTooltip>
        <div
          class="tooltip"
          style="z-index: 10000; max-width: 300px"
          ngpTooltip
        >
          The creator of the game has chosen to only allow pure items to be
          deposited into the game.
        </div>
      </ng-template>
    </div>
    }
  </ng-content>
  <ng-content inventory-bottom>
    @if (isJoinModal()) {
    <div class="cf--join-amount-difference">
      <p class="cf--join-amount-difference__title">Amount needed to join</p>
      <span class="cf--join-amount-difference__description">
        Choose value between that range in order to join
      </span>
      <div class="w-full flex items-center gap-8">
        <app-cost
          [gap]="4"
          [cost]="coinflip()?.min_val ?? 0"
          [balanceType]="coinflip()?.is_pure ? 'pure' : 'skins'"
        ></app-cost>
        -
        <app-cost
          [gap]="4"
          [cost]="coinflip()?.max_val ?? 0"
          [balanceType]="coinflip()?.is_pure ? 'pure' : 'skins'"
        ></app-cost>
      </div>
    </div>
    } @else {
    <div class="cf--join-amount-difference">
      <p class="cf--join-amount-difference__title">Join amount difference</p>
      <span class="cf--join-amount-difference__description">
        Join % difference when a players joins you
      </span>

      <div class="cf--join-amount-difference__slider w-full">
        <span class="cf--join-amount-difference__slider-value">
          {{ joinDifference().toFixed() }}%
        </span>
        <app-old-slider
          [(value)]="joinDifference"
          [min]="minJoinDifference"
          [max]="maxJoinDifference"
          [uiSettings]="{
            thumbSize: '12px',
            trackHeight: '6px',
          }"
        ></app-old-slider>
      </div>
    </div>
    <div class="cf--coins__toggle">
      <app-coinflip-coin
        (click)="setCoin(1)"
        [class.selected]="coin() === 1"
        [class.disabled]="isJoinModal() && coinflip()?.host?.side === 1"
        [side]="1"
        [size]="'36px'"
      ></app-coinflip-coin>
      <app-coinflip-coin
        (click)="setCoin(2)"
        [class.selected]="coin() === 2"
        [class.disabled]="isJoinModal() && coinflip()?.host?.side === 2"
        [side]="2"
        [size]="'36px'"
      ></app-coinflip-coin>
    </div>
    }
  </ng-content>
</app-inventory-template>
